import api from '@/apis/di/projectAPI.js';
import {usefilterActionCombo} from './filterActionCombo.js';
import {getCurrentInstance} from 'vue';

// Combo grid CTMT
export const useProjectComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const {proxy} = getCurrentInstance();
  const {extendFilter} = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onProjectComboboxLoadData = (payload, row, column) => {
    let ors = [{Field: 'inactive', Operator: 'NULL'}];
    let extend = [
      {Field: 'inactive', Value: false, Ors: ors},
      {
        Field: 'is_parent',
        Value: false,
        Ors: [{Field: 'is_parent', Operator: 'NULL'}],
      },
    ];
    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'project_code';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };
  // func lấy dữ liệu cha và con có trạng thái theo dõi
  const onProjectComboboxLoadAllDataInactive = (payload, row, column, custom) => {
    let ors = [{Field: 'inactive', Operator: 'NULL'}];
    let extend = [{Field: 'inactive', Value: false, Ors: ors}];
    payload.columns += ',project_name,object_type_name,misa_code_id';
    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'project_code';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // func call api lấy dữ liệu combo
  const onProjectLoadData = (payload, row, column, custom) => {
    let ors = [{Field: 'inactive', Operator: 'NULL'}];
    let orsIsParent = [{Field: 'is_parent', Operator: 'NULL'}];
    let extend = [
      {Field: 'inactive', Value: false, Ors: ors},
      {Field: 'is_parent', Value: false, Ors: orsIsParent},
    ];
    payload.filter = [...JSON.parse(payload.filter || '[]'), ...extend];
    payload.sort = 'project_code';
    custom && custom(payload);
    Array.isArray(payload.filter) && (payload.filter = JSON.stringify(payload.filter));

    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // func call api lấy dữ liệu combo
  const onProjectCommonComboboxLoadData = (payload, row, column, customData) => {
    let orsIsParent = [{Field: 'is_parent', Operator: 'NULL'}];
    let extend = [
      {Field: 'inactive', Value: false},
      {Field: 'is_parent', Value: false, Ors: orsIsParent},
      {Field: 'object_type', Value: 1}, // load lên CTMT chi tiết nhất
    ];
    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'project_code';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, customData?.callBackFn);
  };

  // func call api lấy dữ liệu combo CTMT và DA
  const onTargetProjectComboboxLoadData = (payload, row, column, customData) => {
    let UnSelectedID = '4E954D08-21CD-41C8-9200-E8C9B093B20C'; //'4E954D08-21CD-41C8-9200-E8C9B093B20C';
    let orsIsParent = [{Field: 'is_parent', Operator: 'NULL'}];
    let extend = [
      {Field: 'inactive', Value: false},
      {Field: 'is_parent', Value: false, Ors: orsIsParent},
      {
        Field: 'object_type',
        Value: [1, 2],
        Operator: proxy.$ms.constant.FilterOperator.In,
      },
      {
        Field: 'project_id',
        Value: UnSelectedID,
        Operator: proxy.$ms.constant.FilterOperator.NotEquals,
      },

      // load lên CTMT chi tiết nhất
    ];
    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'project_code';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, customData?.callBackFn);
  };

  // func call api lấy tất cả dữ liệu combo
  const onProjectComboboxLoadAllData = (payload, row, column, customData) => {
    payload.sort = 'misa_code_id';
    payload.columns += ',parent_id,is_parent,misa_code_id';
    payload.take = 3000;

    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, customData?.callBackFn);
  };
  // func call api lấy dữ liệu combo CTMT và DA
  const onTargetAllActiveProjectComboboxLoadData = (payload, row, column, customData) => {
    let extend = [
      {Field: 'inactive', Value: false},
      {
        Field: 'object_type',
        Value: [1, 2],
        Operator: proxy.$ms.constant.FilterOperator.In,
      },
      {
        Field: 'project_id',
        Value: '4e954d08-21cd-41c8-9200-e8c9b093b20c',
        Operator: proxy.$ms.constant.FilterOperator.NotEquals,
      },

      // load lên CTMT chi tiết nhất
    ];
    payload.filter = extendFilter(payload.filter, extend);
    payload.columns += ',object_type';
    payload.sort = 'project_code';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, customData?.callBackFn);
  };
  // config columns combo
  const projectComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã CTMT, dự án',
        dataField: 'project_code',
        width: 140,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên CTMT, dự án',
        dataField: 'project_name',
        width: 310,
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      },
      {
        title: 'Loại',
        dataField: 'object_type_name',
        width: 140,
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      },
    ],
    displayField: 'project_code',
    valueField: 'project_id',
    queryMode: 'remote',
    quickSearch: 'ProjectQuickSearch',
    quickSearchParam: {
      isFilter: true,
      filterFunc: x => !x.inactive && !x.is_parent,
    },
    dropdownWidth: 600,
    comboboxLoadData: onProjectComboboxLoadData,
  };

  // config columns combo load cha và con trạng thái theo dõi
  const projectAllDataInactiveComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã CTMT, dự án',
        dataField: 'project_code',
        width: 140,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên CTMT, dự án',
        dataField: 'project_name',
        width: 310,
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      },
      {
        title: 'Loại',
        dataField: 'object_type_name',
        width: 140,
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      },
    ],
    displayField: 'project_code',
    valueField: 'project_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onProjectComboboxLoadAllDataInactive,
  };

  // config columns combo grid nhập dự toán
  const projectBUPlanImportComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã CTMT, dự án',
        dataField: 'project_code',
        width: 140,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên CTMT, dự án',
        dataField: 'project_name',
        width: 460,
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      },
    ],
    displayField: 'project_name',
    valueField: 'project_id',
    queryMode: 'remote',
    quickSearch: 'ProjectQuickSearch',
    quickSearchParam: {
      isFilter: true,
      filterFunc: x => !x.inactive && !x.is_parent,
    },
    dropdownWidth: 600,
    comboboxLoadData: onProjectComboboxLoadData,
  };
  // config columns Chương trình mục tiêu dự án
  const targetProjectBUPlanImportComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã CTMT, dự án',
        dataField: 'project_code',
        width: 140,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên CTMT, dự án',
        dataField: 'project_name',
        width: 460,
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      },
    ],
    displayField: 'project_name',
    valueField: 'project_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onTargetProjectComboboxLoadData,
  };
  return {
    projectComboConfig,
    onProjectCommonComboboxLoadData,
    onTargetProjectComboboxLoadData,
    onProjectLoadData,
    projectBUPlanImportComboConfig,
    targetProjectBUPlanImportComboConfig,
    onProjectComboboxLoadData, // trả về thêm để dùng chung chả cả combo ko thuộc grid
    onProjectComboboxLoadAllData,
    projectAllDataInactiveComboConfig,
    onProjectComboboxLoadAllDataInactive,
    onTargetAllActiveProjectComboboxLoadData,
  };
};
